'use strict';

export function initInScope($scope) {
    let $redirectUrlInput = $scope.find('.js-redirect-url');
    let redirectUrl = window.location.pathname;

    $redirectUrlInput.val(redirectUrl);
}